import {nextTick} from "vue";

export default async function (callback) {
    await nextTick(() => {
        requestAnimationFrame(() => {
            requestAnimationFrame( callback );
        } );
    } );
}